// @ts-nocheck

import styled, { keyframes } from 'styled-components';

import { CircleStroke } from '../../assets/svg';

const rotatespinnerAnim = keyframes`
  to {
    transform: translate(-50%,-50%) rotateZ(359deg);
  }
`;

const strokeSpinnerAnim = keyframes`
  50% {
    stroke-dasharray: 100;
    stroke-dashoffset: 50;
  }
`;

const SimpleSpinner = styled(CircleStroke)`
  position: absolute;
  width: 1.3em;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  background: transparent;
  animation: ${rotatespinnerAnim} 829ms linear infinite;

  circle {
    stroke-dasharray: 100;
    stroke-dashoffset: 95;

    animation: ${strokeSpinnerAnim} 2000ms ease-in-out infinite;
  }
`;

export default SimpleSpinner;
